import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/PageHeader'
import { useNavigate } from 'react-router-dom'
import { FaArrowCircleLeft, FaArrowCircleRight, FaMedkit } from 'react-icons/fa'
import ReusableModal from '../../shared/ReuseableModal'
import { FaArrowsRotate, FaPlus } from 'react-icons/fa6'
import {
  useGetSpecialitiesListQuery,
  useSeedSpecialitiesMutation,
} from '../../redux/api/modules/managementApi'
import toast from 'react-hot-toast'

import CustomButton from '../../shared/CustomButton'
import SpecialityTable from '../../components/his/Speciality/SpecialityTable'
import SpecialityForm from '../../components/his/Speciality/SpecialityForm'
import { useTranslation } from 'react-i18next'
import SearchField from '../../shared/SearchField'
import AutoCompleteField from '../../shared/AutoCompleteField'
import useDebouncedCallback from '../../hooks/DebounceUseCallback'
import usePersistedFilters from '../../hooks/usePersistedFilters'
import CheckPermission from '../../hooks/CheckPermission'

function Specialities () {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { hasPermission } = CheckPermission()
  const [openModal, setOpenModal] = useState(false)
  const [selectedData, setSelectedData] = useState(null)
  const {
    data: rtkData,
    isLoading: queryLoading,
    isFetching: queryFetching,
    refetch
  } = useGetSpecialitiesListQuery({ is_show_all: true })
  const loading = queryLoading || queryFetching
  const [allData, setAllData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [seedSpecialities, { isLoading: isSeedingSpecialities }] = useSeedSpecialitiesMutation()

  const defaultFilters = {
    name: '',
    department: '',
    is_show_all: true
  }

  const {
    filters: payloadData,
    setFieldValue,
    setFilters: setPayloadData
  } = usePersistedFilters('specialities_list', defaultFilters)

  const handleSeedSpecialities = async () => {
    if (!hasPermission('speciality', 'create')) return
    try {
      const res = await seedSpecialities({}).unwrap()
      toast.success(res?.message || 'Specialities seeded successfully')
    } catch (error) {
      toast.error(error?.data?.message || error?.message || 'Failed to seed specialities')
    }
  }

  useEffect(() => {
    if (rtkData?.data) {
      setAllData(rtkData?.data)
      setFilteredData(rtkData?.data)
    }
  }, [rtkData])

  const handleFilterChange = (key, value) => {
    let updated = { ...payloadData, [key]: value }

    if (key === 'name') {
      updated = { ...updated, department: '' }
      setFieldValue('department', '')
    }

    if (key === 'department') {
      updated = { ...updated, name: '' }
      setFieldValue('name', '')
    }

    setFieldValue(key, value)

    let filtered = allData

    if (updated.name) {
      filtered = filtered?.filter(item =>
        item.name_en?.toLowerCase()?.includes(updated?.name?.toLowerCase())
      )
    }

    if (updated.department) {
      filtered = filtered?.filter(item =>
        item?.department?.name_en
          ?.toLowerCase()
          .includes(updated?.department?.toLowerCase())
      )
    }

    setFilteredData(filtered)
  }

  return (
    <div className='main-page-container !overflow-y-auto scrollbar'>
      <PageHeader
        title={t('specialities')}
        iconSize={20}
        Icon={i18n.dir() === 'rtl' ? FaArrowCircleRight : FaArrowCircleLeft}
        onIconClick={() => navigate(-1)}
      >
        <div className='flex-1 flex md:items-center flex-col md:flex-row gap-2'>
          <SearchField
            className='w-full sm:w-[250px]'
            name='name'
            placeholder={t('Filter by name')}
            handleClearClick={() => handleFilterChange('name', '')}
            value={payloadData?.name || ''}
            onChange={e => handleFilterChange('name', e.target.value)}
          />
          <SearchField
            className='w-full sm:w-[250px]'
            name='department'
            placeholder={t('Filter by department')}
            value={payloadData?.department || ''}
            handleClearClick={() => handleFilterChange('department', '')}
            onChange={e => handleFilterChange('department', e.target.value)}
          />
          {hasPermission('speciality', 'create') && <CustomButton
            label={t('Seed Specialities')}
            buttonType='secondary'
            icon={FaArrowsRotate}
            loading={isSeedingSpecialities}
            onClick={handleSeedSpecialities}
          />}
          {/* <CustomButton
            label={t("add_speciality")}
            icon={FaPlus}
            onClick={() => {
              setOpenModal(true);
              setSelectedData(null);
            }}
          /> */}
        </div>
      </PageHeader>
      <div className='mt-2 w-full h-full'>
        <SpecialityTable
          specialityData={filteredData}
          loading={loading}
          payloadData={payloadData}
         // setPayloadData={setPayloadData}
          setOpenModal={setOpenModal}
          setSelectedData={setSelectedData}
          selectedData={selectedData}
          refetch={refetch}
        />
      </div>
      <ReusableModal
        isVisible={openModal}
        title={
          selectedData ? t('update_speciality') : t('create_new_speciality')
        }
        HeaderIcon={FaMedkit}
        position='top'
        onClose={() => {
          setOpenModal(false)
          setSelectedData(null)
        }}
      >
        <SpecialityForm
          refetch={refetch}
          setOpenModal={setOpenModal}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          payloadData={payloadData}
        />
      </ReusableModal>
    </div>
  )
}

export default Specialities
